import { postMessageToNative } from "~/lib/webview";
import { isNativeApplication } from "./platform";

export type ReproEventProps = Record<string, string | number | boolean>;

/**
 * Repro にイベントを1件送信する。通常は `trackEvent()` 経由で呼び出すこと。
 * source / pointsConsumed によるサフィックスイベントの多重送信は trackEvent 側で制御する。
 */
export const trackReproEvent = (eventName: string): void => {
  if (!isNativeApplication()) return;

  // 直後に WebView が破棄される経路（新規登録→Carina の開き直し）で落ちないよう同期で送る
  try {
    postMessageToNative({
      type: "REPRO_TRACK",
      payload: { event: eventName, props: {} },
    });
  } catch {
    // 補助機能のため例外は握りつぶす
  }
};
